export default __webpack_public_path__ + "static/media/productHealthCheckPackage2_male_En.2b1cb3f6.webp";